import script from "./PostCreateView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostCreateView.vue?vue&type=script&setup=true&lang=ts"

import "./PostCreateView.vue?vue&type=style&index=0&id=3e26dcde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e26dcde"]])

export default __exports__